import {Injectable} from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot, UrlTree, Router,
} from '@angular/router';
import {Observable} from "rxjs";
import {ApiService} from "../services/api.service";
import {SettingsService} from "../services/settings.service";
import {UserService} from "../services/user.service";

@Injectable({providedIn: 'root'})
export class RetrieveSession implements CanActivate {
  constructor(private api: ApiService, private user: UserService, private settings: SettingsService, public router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return new Promise(async (resolve) => {
      if(this.user.currentUserValue){
        // THIS GUARD HAS ALREADY RUN SUCCESSFULLY, SO JUST LET THEM THROUGH
        resolve(true);
      }else{

        this.api.getLoggedInUser().then((User) => {
          this.user.currentUserValue = User;
          resolve(true);
        }).catch((err)=>{
          resolve(false);
        });

      }

    });
  }

}
